import React, { useEffect, useState } from 'react';
import { useMedia } from '../../../hooks';
import { MediaEvents } from '../../../common/media';

type QualityProps = {
  target: string;
};

type TQualityItem = {
  id: number;
  value: string;
};

const Quality = ({ target }: QualityProps) => {
  const media = useMedia(target);
  const [{ list, selected, show }, setState] = useState<{
    list: TQualityItem[];
    selected: number | undefined;
    show: boolean;
  }>({
    list: [],
    selected: undefined,
    show: false,
  });

  useEffect(() => {
    if (!media) return;

    const handleLevelChange = (lvlId: number) => {
      setState(state => ({
        ...state,
        selected: lvlId,
      }));
    };

    const handleReady = () => {
      const levels = media.getLevels();
      const current = media.getCurrentLevel();
      const list = [{ id: -1, value: 'auto' }, ...levels.map((_, i) => ({ id: i, value: `${_.width}p` }))].reverse();
      const selected = list.find(_ => _.id === current)?.id;

      setState(state => ({
        ...state,
        list,
        selected,
      }));
    };

    media.on(MediaEvents.Ready, handleReady);
    media.on(MediaEvents.Change_Level, handleLevelChange);

    return () => {
      media.off(MediaEvents.Ready, handleReady);
      media.off(MediaEvents.Change_Level, handleLevelChange);
    };
  }, [media]);

// 

  return (
    <div className="player-footer-settings-box position-relative">
      <div
        className="player-footer-settings"
        onClick={() => setState(state => ({ ...state, show: !state.show }))}></div>

      <div className={`player-footer-settings-list ${show ? 'open' : ''}`}>
        <ul>
          {list.map((lvl, i) => {
            return (
              <li
                key={lvl.id}
                onClick={() => {
                  media?.setLevel(lvl.id);
                }}
                className={`${selected === lvl.id ? 'active' : ''}`}>
                <button type="button">{lvl.value}</button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Quality;
